import { Component } from "react"

/* Components */
import { Input } from "../../components"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* REST API */
import { password as changePassword } from "../../api/Admin"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* Helpers */
import { utils, withRouter } from "../../helpers"

/* Swal */
import Swal from "sweetalert2"



/* Page Admin Change Password */
class AdminChangePassword extends Component {

    constructor() {
        super()

        this.state = {
            password: "",
            repeatPassword: "",
            waiting: false,
        }
    }

    /* Save action */
    save = () => {

        const { password, repeatPassword } = this.state
        const { navigate, params } = this.props
        const { id } = params

        if (!id) {
            Swal.fire(utils.notification(t("swal.generic"), "error"))
            return
        }

        if (password === "" || password === null || password === undefined) {
            this._password.error(t("admin.error.emptyPassword"))
            return
        }

        if (password.length < 8) {
            this._password.error(t("admin.error.shortPassword"))
            return
        }

        if (password !== repeatPassword) {
            this._repeatPassword.error(t("profile.error.mismatch"))
            return
        }

        this.setState({ waiting: true })

        changePassword({ id, password }).then((response) => {
            if (response.status === 200) {
                Swal.fire(utils.notification(t("admin.passwordSaved"), "success")).then(() => {
                    navigate(-1)
                })
            }
            else if (response.status === 401 || response.status === 403) {
                Swal.fire(utils.notification(t("swal.noAccess"), "error"))
            }
            else if (response.status === 498) {
                Swal.fire(utils.notification(t("swal.invalidKey"), "error"))
            }
            else {
                Swal.fire(utils.notification(t("swal.generic"), "error"))
            }
        }).catch(() => {
            Swal.fire(utils.notification(t("swal.generic"), "error"))
        }).finally(() => {
            this.setState({ waiting: false })
        })


    }

    /* Generate Password */
    generatePassword = () => {
        const password = utils.generatePassword()
        this.setState({ password, repeatPassword: password })
    }

    /* Draw button */
    _button = () => {

        const { waiting } = this.state

        if (waiting) {
            return <div className="button"><LoadingOutlined /></div>
        }

        return <div onClick={() => this.save()} className="button">{t("common.save")}</div>
    }

    render = () => {

        const { password, repeatPassword } = this.state

        return (
            <div className="page">

                <div className="page-header">
                    <h1>{t("admin.changePassword")}</h1>
                </div>

                <div className="page-form">

                    <div className="form">
                        <div className="form-box">
                            <Input ref={(ref) => this._password = ref} label={t("admin.newPassword")} value={password} onChange={(event) => this.setState({ password: event.target.value })} secure />
                            <Input ref={(ref) => this._repeatPassword = ref} label={t("admin.repeatNewPassword")} value={repeatPassword} onChange={(event) => this.setState({ repeatPassword: event.target.value })} secure />
                            <div onClick={() => this.generatePassword()} className="form-generate-password">{t("common.generatePassword")}</div>
                        </div>
                    </div>

                    <div className="form-bottom">
                        {this._button()}
                    </div>

                </div>

            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps)(withRouter(AdminChangePassword))